import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Marketdate } from './marketdate.model';
import { MarketdateService } from './marketdate.service';

@Component({
    selector: 'jhi-marketdate-detail',
    templateUrl: './marketdate-detail.component.html'
})
export class MarketdateDetailComponent implements OnInit, OnDestroy {

    marketdate: Marketdate;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketdateService: MarketdateService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdates();
    }

    load(id) {
        this.marketdateService.find(id).subscribe((marketdate) => {
            this.marketdate = marketdate;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdates() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateListModification', (response) => this.load(this.marketdate.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate-detail.component.ts